module.exports = __webpack_public_path__ + "static/img/img_2.11246cad.png";